<template>
  <tg-layout>
    <template slot="header">
      <tg-search-tool @on-submit="handleSearch">
        <tg-date-search
          ref="dateSearch"
          size="small"
          v-model="dateRange"
          showDateRangePicker
          twoMonthLimit
        ></tg-date-search>
      </tg-search-tool>
      <span class="fs-sm">{{ $t("note.twoMonthOnly") }}</span>
    </template>
    <tg-form-table
      :columns="columns"
      :caption="$t('menu.accounts.income')"
      :data="tableData"
      :fenceCol="2"
      :fenceRow="5"
      showActionCell
      v-loading="loading"
      :element-loading-text="loadingLabel"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <template slot="decimal" slot-scope="scope">
        <span
          :class="{
            'text-red': scope.value < 0,
            'text-green': scope.value > 0,
          }"
          >{{ scope.formated }}</span
        >
      </template>
      <template slot="action.commission_profit" slot-scope="scope">
        <el-row type="flex" justify="center" align="middle">
          <i
            v-if="scope.row[scope.column.name] != 0"
            class="tg-icon tg-icon-exclamation-mark clickable"
            @click="handleShowDetail({'platform':'tg','category':0})"
          ></i>
        </el-row>
      </template>
      <template slot="action.shares_profit" slot-scope="scope">
        <el-row type="flex" justify="center" align="center">
          <i
            v-if="scope.row[scope.column.name] != 0"
            class="tg-icon tg-icon-exclamation-mark clickable"
            @click="handleShowDetail({'platform':'tg','category':0})"
          ></i>
        </el-row>
      </template>
     
        <template v-for="item in third_party" :slot="'action.'+item.platform+'_shares_profit'" slot-scope="scope" >
          <el-row type="flex" justify="center" align="center" :key="item.platform">
            <i
              v-if="scope.row[scope.column.name] != 0"
              class="tg-icon tg-icon-exclamation-mark clickable"
              @click="handleShowDetail(item)"
            ></i>
          </el-row>
        </template>
      
      
    </tg-form-table>
    <span class="text-danger fs-sm">{{ $t("note.breakwater") }}</span>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgFormTable from "@/components/table/TgFormTable";

import apis from "@/apis";

const api = apis.accounts.income;

export default {
  components: {
    TgLayout,
    TgSearchTool,
    TgDateSearch,
    TgFormTable,
  },
  data() {
    return {
      dateRange: {},
      columns: [],
      tableData: {},
      loading: false,
      third_party:[],
    };
  },
  created() {
    if (this.thirdParties.length > 0) {
      let array = [];
      this.thirdParties.forEach(element => {
        array.push(element);
      });
      this.third_party = array;
    }
    this.fetch();
  },
  computed: {
    request() {
      return this.dateRange;
    },
    loadingLabel() {
      return this.$t("component.table.loading");
    },
  },
  methods: {
    fetch() {
      this.$nextTick(() => {
        this.loading = true;
        api.getData(this.request).then((response) => {
          if(response.retcode == 0){
            this.columns = response.columns;
            this.tableData = response.data;
            this.loading = false;
          }
        });
      });
    },
    handleSearch() {
      this.fetch();
    },
    handleShowDetail(type) {
      console.log("dataRange", this.dateRange);
      this.$router.push({
        name: "accounts.income.detail",
        params: {...this.dateRange, entry: type},
      });
    },
  },
};
</script>
